export default __webpack_public_path__ + "static/media/icon-nft.782686a1.svg";